/**
* DevExpress HTML/JS Reporting (viewer\exportOptions\pdfExportOptionsPreview.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { PdfExportOptions } from '../../common/exportOptions/pdfExportOptions';
import { viewerEditorTemplates } from '../widgets/editorTemplates';
export class PdfExportOptionsPreview extends PdfExportOptions {
    constructor(model, serializer, _signatures) {
        super(model, serializer);
        this._signatures = _signatures;
        this.signature = ko.observable();
    }
    getInfo() {
        return [
            { propertyName: 'signature', defaultVal: null, editor: viewerEditorTemplates.signatures, displayName: 'Signature', localizationId: 'PreviewStringId.EditingFieldEditors_Signature' },
            ...super.getInfo()
        ];
    }
    isPropertyVisible(name) {
        return name !== 'signature' || this._signatures().length;
    }
}
